import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const BranchesPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <span className="text-4xl">🏢</span>
        <h1 className="text-3xl font-bold">Multi-Branch Management</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
            alt="Business branches"
            className="rounded-lg shadow-md w-full h-64 object-cover"
          />

          <div className="mt-6 space-y-6">
            <div className="flex items-start gap-4">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-red-500 mt-1"
              />
              <div>
                <h3 className="font-medium">Centralized Dashboard</h3>
                <p className="text-gray-600">
                  Manage all locations from one control panel
                </p>
              </div>
            </div>

            {/* More features... */}
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Pricing</h2>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <div className="flex justify-between items-center mb-4">
              <span>Base Price</span>
              <span className="font-bold">10,000 MMK/month</span>
            </div>
            <div className="flex justify-between items-center mb-4">
              <span>Additional Branches</span>
              <span className="font-bold">5,000 MMK/branch</span>
            </div>

            <button className="mt-6 w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition">
              Start Managing Branches
            </button>
          </div>

          {/* Branch performance section... */}
        </div>
      </div>
    </div>
  );
};

export default BranchesPage;
